export default "__VITE_ASSET__79Z1z8SX__"